(() => {
  const desktop = window.matchMedia('(min-width: 701px)');
  const initialize = () => {
    const back = document.querySelector('.wwh-footer #back-top');
    if (back && window.jQuery) window.jQuery(back).hide();
    document.querySelectorAll('.wwh-footer__menu').forEach(menu => {
      const summary = menu.querySelector('summary');
      menu.open = desktop.matches;
      summary.tabIndex = desktop.matches ? -1 : 0;
      if (!menu.dataset.wwhReady) {
        summary.addEventListener('click', event => { if (desktop.matches) event.preventDefault(); });
        menu.dataset.wwhReady = 'true';
      }
    });
  };
  initialize();
  desktop.addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  // Preserve the existing footer's back-to-top interaction.
  if (window.jQuery) {
    window.jQuery(window).on('scroll.wwhFooter', () => {
      window.jQuery('.wwh-footer #back-top').toggle(window.scrollY > document.body.scrollHeight / 3);
    });
    window.jQuery(document).on('click.wwhFooter', '.wwh-footer #back-top', () => { window.jQuery('body,html').animate({ scrollTop: 0 }, 800); return false; });
  }
})();
